// extracted by mini-css-extract-plugin
module.exports = {"Testimonials":"testimonials-module--Testimonials--3Vbeq","item":"testimonials-module--item--JVbqp"};